import React from "react";

import { useNotify, useDataProvider,useAuthenticated } from "react-admin";

import { TextField, Radio } from "final-form-material-ui";

import { Form, Field } from "react-final-form";

import Grid from "@material-ui/core/Grid";
import RadioGroup from "@material-ui/core/RadioGroup";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import { FormLabel, FormControlLabel, FormControl } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyle = makeStyles({
  button: {
    color: "#fff",
  },
  loader: {
    color: "#fff",
  },
});

const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

// const toBase64 = file => new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = () => resolve(reader.result);
//     reader.onerror = error => reject(error);
//   });

const toBase64 = (url, callback) => {
  let xhr = new XMLHttpRequest();
  xhr.onload = function () {
    var reader = new FileReader();
    reader.onloadend = function () {
      callback(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open("GET", url);
  xhr.responseType = "blob";
  xhr.send();
};
const PersonalDetails = ({ data, uid, profileImage }) => {
  // remove object as submit does not work with it
  delete data["availability"];
  useAuthenticated()
  const classes = useStyle();
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const [loading, setLoading] = React.useState(false);
  const [base64, setBase64] = React.useState("");

  const [notification, setNotification] = React.useState({
    open: false,
    type: "info",
    message: "",
  });
  console.log("profileImage", profileImage);
  const base64Image = toBase64(profileImage, function (myBase64) {
    setBase64(myBase64);
  });
  console.log("base64Image", base64Image);

  const OnSubmit = async (values) => {
    setLoading(true);
    let submitflag = true;
    if (!values.name) {
      notify("Kindly fill your name");
      submitflag = false;
    }
    if (!values.dateOfBirth) {
      notify("Kindly fill Birth Date");
      submitflag = false;
    }
    if (!values.gender) {
      notify("Kindly select your gender");
      submitflag = false;
    }

    if (submitflag) {
      dataProvider
        .update("User", {
          id: uid,
          data: values,
          profileImage: profileImage ? base64 : "",
        })
        .then(
          (success) => {
            setLoading(false);
            setNotification({
              open: true,
              type: "success",
              message: "Person Details Updated Successfully",
            });
          },
          (error) => {
            setLoading(false);
            setNotification({
              open: true,
              type: "error",
              message: "Something went wrong. Please retry",
            });
          }
        );
    }
  };

  const validate = (values) => {
    const errors = {};
    if (!values.name) {
      errors.name = "Required";
    }
    if (!values.dateOfBirth) {
      errors.dateOfBirth = "Required";
    }
    if(new Date(values.dateOfBirth) > new Date()){
      errors.dateOfBirth = "Invalid date";
    }
    if (!values.gender) {
      errors.gender = "Required";
    }
    return errors;
  };
  return (
    <Form
      onSubmit={OnSubmit}
      initialValues={data}
      validate={validate}
      render={({ handleSubmit, reset, submitting, pristine, values }) => (
        <form onSubmit={handleSubmit} noValidate>
          <Grid
            container
            direction="column"
            justify="flex-start"
            alignItems="flex-start"
            spacing={2}
          >
            <Grid item className={classes.row}>
              <Field
                xs={12}
                fullWidth
                required
                name="name"
                component={TextField}
                type="text"
                label="Name"
              />
            </Grid>
            <Grid item className={classes.row}>
              <Field
                xs={12}
                fullWidth
                required
                name="dateOfBirth"
                component={TextField}
                type="date"
                label="Birthday"
              />
                 {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  id="date-picker-dialog"
                  label="Birthdate"
                  required
                  disableFuture={true}
                  format="dd/MM/yyyy"
                  name="dateOfBirth"
                  onChange={e => {
                    console.log("DATE", e);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date"
                  }}
                />
              </MuiPickersUtilsProvider> */}
           
            </Grid>
            <Grid item className={classes.row}>
              <FormControl component="fieldset">
                <FormLabel component="legend">Gender</FormLabel>
                <RadioGroup row>
                  <FormControlLabel
                    label="Male"
                    control={
                      <Field
                        name="gender"
                        component={Radio}
                        type="radio"
                        value="Male"
                      />
                    }
                  />
                  <FormControlLabel
                    label="Female"
                    control={
                      <Field
                        name="gender"
                        component={Radio}
                        type="radio"
                        value="Female"
                      />
                    }
                  />
                  <FormControlLabel
                    label="Choose Not to Specify"
                    control={
                      <Field
                        name="gender"
                        component={Radio}
                        type="radio"
                        value="Choose Not to Specify"
                      />
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item className={classes.row} style={{ marginTop: 16 }}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={loading}
                className={classes.button}
              >
                {!loading ? "Submit" : <CircularProgress />}
              </Button>
            </Grid>
          </Grid>
          <Snackbar open={notification.open} autoHideDuration={800}>
            <Alert severity={notification.type}>{notification.message}</Alert>
          </Snackbar>
        </form>
      )}
    />
  );
};

export default PersonalDetails;
